export function uiStateKey(base: string): string {
  const host = typeof window !== 'undefined' ? window.location.hostname : 'server';
  return `werftools_ui_v1:${host}:${base}`;
}

export function loadUiState<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function saveUiState<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore */
  }
}

